import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@/store/auth.store'
import { DashboardPage } from '@/features/dashboard/pages/DashboardPage'

export const Route = createFileRoute('/_app/dashboard/')({
  beforeLoad: () => {
    const { activeBusiness } = useAuthStore.getState()
    if (!activeBusiness?.is_owner) throw redirect({ to: '/sales', search: { tab: 'sales' } })
  },
  component: DashboardPage,
})
